import ObjectImport from './container';

export default ObjectImport;



// WEBPACK FOOTER //
// ./src/views/Setup/ObjectImport/index.js